<!--
——————————————————————————————————————————————————————————————————————————————————————————————————————
1： isEditing=true等价于直接写一个idEditing，默认false
    false: 只能查看附件
    true: 可以对附件进行增删
————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
2： getItemsBySelf=true等价于直接写一个getItemsBySelf，默认false

    false: 忽略props.attachmentIds，直接使用传递进来的props.items作为附件列表
    e.g.
            <em-attachment
                    v-if="isType(['emAttachment'])"
                    :items="value"
                    :metadata="metadata"
                    :entity="entity"
            ></em-attachment>

    true:  忽略props.items，通过props.attachmentIds自己去后端取数据
    e.g.
        <em-attachment getItemsBySelf :attachmentIds="row.item.attachmentIds"></em-attachment>
——————————————————————————————————————————————————————————————————————————————————————————————————————
3：可以什么都不传，只通过监听ids变化来获取ids，适用于新增记录时。下面是在EmWorkflowTaskComplete组件中的用例
    <em-attachment
            v-if="!attachmentDisable"
            isEditing
            @idsChanged="handleIdsChanged"
    ></em-attachment>

    methods:{
        handleIdsChanged(ids){
            console.log("this is emWorkflowTaskcomplete.handleIdsChanged")
            console.log("ids is")
            console.log(ids)
        }
    }
——————————————————————————————————————————————————————————————————————————————————————————————————————
4：可以传入entity，和metadata，组件就会自动把ids的变化同步到vuex中的entity对象中，根据model中定义的form.correspondingField
            <em-attachment
                    v-if="isType(['emAttachment'])"
                    :items="value"
                    :metadata="metadata"
                    :entity="entity"
                    :isEditing="isEditing"
            ></em-attachment>

-->
<template>
    <div>
        <template v-if="isEditing">
            <b-form-file ref="test"
                         v-model="file"
                         class="w-100 mb-2"
                         :file-name-formatter="formatName"
                         :state="avoidNull || uploadStatus > 0"
                         :placeholder="$t('label.em.components.emAttachment.bFormFile.placeholder')"
                         :drop-placeholder="$t('label.em.components.emAttachment.bFormFile.dropPlaceholder')"
            ></b-form-file>
        </template>
        <ul>
            <li v-for="(attachment,index) of attachmentModels" :key="attachment.attachmentId">
                <div class="d-flex flex-row">
                    <b-form-checkbox
                        v-if="checkEnable"
                        v-model="attachment.checked">
                    </b-form-checkbox>
                    <div
                        class="col-md-8"
                        style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis; float:left">
                        <a :href="downloadUrl+attachment.attachmentId">{{ attachment.fileName }}</a>
                    </div>
                    <em-button
                        v-if="isEditing && deleteEnable"
                        class="col-md-2 btn btn-outline-primary btn-sm"
                        style="line-height:8px; padding:1px 0 0 0; float:right"
                        type="delete"
                        @click="handleClickForItemsDelete(index)"
                    ></em-button>
                </div>
            </li>
        </ul>
        <!--     ids: {{itemsIds}}-->
    </div>
</template>
<script>
import EmButton from "@/components/em/EmButton";
import {mapActions} from "vuex";
import axios from "axios";
import attachmentMixin from "@/mixin/em/common/stuffs/attachment/attachmentMixin";


export default {
    name: "emAttachment",
    components: {EmButton},
    mixins: [attachmentMixin],
    props: {
        //vuex中的模块名（实体类名）
        entity: {
            type: String,
            default: ""
        },
        metadata: Object,
        isEditing: {
            type: Boolean,
            default: false
        },
        items: [Object, Array, String],
        attachmentIds: String,
        getItemsBySelf: {
            type: Boolean,
            default: false
        },
        avoidNull: {
            type: Boolean,
            default: false
        },
        checkEnable: {
            type: Boolean,
            default: false
        },
        checkedAttachmentIds: String,
        deleteEnable: {
            type: Boolean,
            default: true
        },
        //需要为get mapping并支持参数attachmentIds
        queryApi: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL +
                "/emAttachment/getAttachmentList"
        },
        encrypted: {
            type: Boolean,
            default: false
        },
        businessModuleCode: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            //准备上传的文件
            // files: [],
            file: [],
            attachmentModels: Object.assign([], this.items),
            //准备上传的文件的加工后的信息
            // filesInfo: [],
            //上传是否成功
            uploadSuccess: 0,
            //上传状态
            uploadStatus: 0,
            //上传进度
            uploadPercentage: 0,
            downloadUrl:
                process.env.VUE_APP_EM_ADMIN_URL +
                "/emAttachment/download?attachmentId=",
            checkInit: false
        };
    },
    computed: {
        itemsIds: function () {
            if (this.attachmentModels) {
                return this.attachmentModels.map(x => x.attachmentId).join(",");
            } else {
                return null
            }
        }
    },
    watch: {
        file: function () {
            this.uploadStatus = this.refreshUploadStatus(this.file, this.businessModuleCode);
            this.uploadPercentage = 0;
            this.uploadSuccess = 0;
            this.handlerUpload();
        },
        uploadStatus: function (newStatus, oldStatus) {
            if (newStatus < 0) {
                this.showDangerAlert(this.getAlertStr(newStatus));
            } else if (newStatus >= 0 && oldStatus < 0) {
                this.showSuccessAlert(this.getAlertStr(newStatus));
                this.hiddenDangerAlert();
            } else {
                this.showSuccessAlert(this.getAlertStr(newStatus));
            }
        },
        itemsIds: function (newValue) {
            //如果有entity，也有metadata.form.correspondingField，就调用函数去改变vuex中entity存放ids字段的值
            if (this.entity && this.entity !== "" && this.metadata && this.metadata.form.correspondingField) {
                this.changeEntityAttribute(
                    this.entity,
                    this.metadata.form.correspondingField,
                    newValue
                );
            }
            //向外触发ids改变事件
            this.$emit("idsChanged", newValue);
        },
        //让EmAttachment可以响应items数据的变化，例如在EmModalEntityViewer中
        items: function (newValue) {
            if (!this.getItemsBySelf) {
                this.attachmentModels = Object.assign([], newValue)
            }
        },
        //让EmAttachment可以响应attachmentIds数据的变化，例如在EmModalEntityViewer中
        attachmentIds: {
            handler(newValue) {
                if (this.getItemsBySelf) {
                    this.getAttachmentListByAttachmentIds(newValue);
                }
            },
            immediate: true
        },
        attachmentModels: {
            handler() {
                if (this.checkEnable && this.checkInit) {
                    this.$emit('checkChanged', this.getCheckedAttachments());
                }
            },
            deep: true
        }
        //监控files的变化，来维护filesInfo
        // files: function() {
        //   //查询files中有，而filesInfo中没有的文件，并push到filesInfo中。按文件名查询
        //   for (let file of this.files) {
        //     if (!this.filesInfo.some(fileInfo => fileInfo.name === file.name)) {
        //       let item = {
        //         name: file.name,
        //         uploadPercentage: 1,
        //         size: this.formatFileSize(file.size, 0),
        //         uploadStatus: this.getUploadStatus(file),
        //         file
        //       };
        //       console.log(item);
        //       this.filesInfo.push(item);
        //     }
        //   }
        //   //把filesInfo中有，而files中没有的文件从filesInfo中过滤掉。按文件名过滤
        //   this.filesInfo = this.filesInfo.filter(fileInfo =>
        //     this.files.some(file => file.name === fileInfo.name)
        //   );
        // }
    },
    methods: {
        ...mapActions("base", ["showSuccess", "showDanger", "showWarning"]),
        showSuccessAlert(str) {
            this.showSuccess({userAlertSuccessStr: str});
        },
        showDangerAlert(str) {
            this.showDanger({
                userAlertDangerStr: str,
                userAlertDangerVisible: true
            });
        },
        hiddenDangerAlert() {
            this.showDanger({
                userAlertDangerStr: "",
                userAlertDangerVisible: false
            });
        },

        // handleClickForFormFileDelete: function(index) {
        //   // this.files = this.files.filter(f => f.name != fileName);
        //   this.files.splice(index, 1);
        // },
        handleClickForFormFileCancel: function () {
            this.file = null;
        },
        handleClickForItemsDelete: function (index) {
            this.attachmentModels.splice(index, 1);

        },
        handlerUpload: function () {
            if (this.uploadStatus <= 0) {
                return;
            }
            let this_ = this;
            const ifEncrypted = this.encrypted ? '/encrypt' : '';
            const businessModuleCode = this.businessModuleCode ? '?businessModuleCode='+this.businessModuleCode : '';
            const url = process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/upload" + ifEncrypted+businessModuleCode;
            //开始上传文件 新建一个formData
            let param = new FormData();
            // param.append("name", "attachmentFile");
            //通过append向form对象添加数据
            param.append("file", this.file);
            //FormData私有类对象，访问不到，可以通过get判断值是否传进去
            // console.log(param.get("file"));
            //通过axios上传文件
            //配置
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt
            }
            headers['Content-Type'] = "multipart/form-data"
            let config = {
                //添加请求头
                headers: headers,
                //添加上传进度监听事件
                onUploadProgress: e => {
                    this_.uploadPercentage = (((e.loaded / e.total) * 100) | 0) + "%";
                }
            }
            this.uploadStatus = 2;
            axios
                .post(url, param, config)
                .then(function (response) {
                    //添加返回值到attachmentModels中
                    this_.addAttachmentModels(response.data);
                    this_.uploadStatus = 3;
                })
                .catch(function (error) {
                    console.log(error);
                    this_.uploadStatus = -1;
                });
        },
        //把上传的返回值填入attachmentModels中
        addAttachmentModels(data) {
            let attachmentModel = {
                attachmentId: data.id,
                fileName: data.fileName + "." + data.fileNameExt,
                fileSize: data.fileSize
            };
            this.attachmentModels.push(attachmentModel);
        },
        //计算文件大小
        formatFileSize: function (fileSize, idx) {
            var units = ["B", "KB", "MB", "GB"];
            idx = idx || 0;
            if (fileSize < 1024 || idx === units.length - 1) {
                return fileSize.toFixed(1) + units[idx];
            }
            return this.formatFileSize(fileSize / 1024, ++idx);
        },
        //检查文件是否已在attachmentModels中
        checkFileExist: function (file) {
            return this.attachmentModels.some(m => m.fileName === file.name);
        },
        //统一对文件做检查
        refreshUploadStatus: function (file, businessModuleCode) {
            if (!file) {
                return 0;
            } else if (!this.checkFileType(file.name.split(".").pop())) {
                return -2;
            } else if (!this.checkFileSize(file.size, businessModuleCode)) {
                return -3;
            } else if (this.checkFileExist(file)) {
                return -4;
            }
            return 1;
        },
        changeEntityAttribute(entity, field, newValue) {
            this.$store.commit(entity + "/setEntityAttribute", {
                key: field,
                newValue: newValue
            });

        },
        formatName(files) {
            return files[0].name.length > 9 ? files[0].name.substr(0, 7) + "..." : files[0].name
        },
        /**
         * 通过ids向后端请求AttachmentList数据
         * @param attachmentIds
         * @returns {null}
         */
        getAttachmentListByAttachmentIds(attachmentIds) {
            this.$emit('loading', true);
            if (attachmentIds === undefined || attachmentIds === '') {
                this.attachmentModels = Object.assign([], this.items);
            }
            //getAttachmentModelListByIds
            console.log("this is EmAttachment.getAttachmentListByAttachmentIds");
            let url = this.queryApi + "?attachmentIds=" + attachmentIds;
            this.$store.dispatch('api/get', {url: url}).then(response => {
                if (response.length > 0) {
                    this.attachmentModels = response;
                } else {
                    this.attachmentModels = Object.assign([], this.items);
                }
            }).finally(() => {
                this.initAttachmentModels();
                this.$emit('loading', false);
            });
        },
        getCheckedAttachments() {
            let tempList = [];
            for (let item of this.attachmentModels) {
                if (item.checked) {
                    tempList.push(item.attachmentId);
                }
            }
            return tempList.join(",");
        },
        initAttachmentModels() {
            if (this.checkEnable && this.checkedAttachmentIds !== undefined && this.checkedAttachmentIds.length > 0) {
                let strings = this.checkedAttachmentIds.split(",");
                for (let item of this.attachmentModels) {
                    if (strings.some(o => o === item.attachmentId + '')) {
                        item.checked = true;
                    }
                }
            }
            this.checkInit = true;
            this.$forceUpdate()
        }
    }

    //下载
    // downloadAttachment(attachmentId){
    //   const url = process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=";
    //   console.log("准备下载："+attachmentId)
    //   this.$store.dispatch("api/get",{url:url+attachmentId})
    // }
    // formatNames(files) {
    //   if (files.length === 1) {
    //     return files[0].name;
    //   } else {
    //     return `${files.length} files selected`;
    //   }
    // }
}
</script>

<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}

.w-100 >>> .custom-file-label {
    width: 100%;
}
</style>
